import * as Sentry from '@sentry/browser'
import './fns/console.log'
import { captureException } from './fns/captureException'
import { capturePromiseRejection } from './fns/capturePromiseRejection'

// Sentry configuration
Sentry.init({
  dsn: 'https://4b83082f017c45198ae871f483b723c8@sentry.io/109140',
  release: `${process.env.GIT_REVISION}`,
  environment: `${process.env.NODE_ENV || 'production'}`,
  sampleRate: 1.0,
  maxBreadcrumbs: 100
})

if ('addEventListener' in window) {
  // Handle unhandled Errors
  // window.addEventListener('error', (event = {}) => {
  //   event && event.preventDefault && event.preventDefault()
  //   console.log('!!! ERROR (errors.unhandledException) Encountered unhandled exception.')
  //   console.log(event)
  //   Sentry && Sentry.captureException(event)
  // })

  // // Handle unhandled Promise rejections
  // window.addEventListener('unhandledrejection', (event = {}) => {
  //   event && event.preventDefault && event.preventDefault()
  //   console.log('!!! ERROR (errors.unhandledPromiseRejection) Encountered unhandled promise rejection.')
  //   console.log(event)
  //   Sentry && Sentry.captureException(event)
  // })
}

const errorMonitoring = {
  captureException: captureException.initialize(Sentry),
  capturePromiseRejection: capturePromiseRejection.initialize(Sentry)
}

Object.assign(MK, errorMonitoring)

export const errors = {
  initialize() {
    console.log(`DEBUG (errors) Initializing error monitoring for ${process.env.NODE_ENV || ''} environment.  Revision: ${process.env.GIT_REVISION}`)

    return errorMonitoring
  }
}